const initialState = {
    auth:""
}

export default function(state = initialState, action){
    switch(action.type){
        case "START_LOGOUT_REQUEST":
            return {
                ...state,
                isLogout:false
            }
        case "START_LOGOUT_SUCCESS":
            return {
                ...state,
                isLogout:true
            }
        default: return state
    }

}
